import { Autocomplete, TextField, autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { type Control, Controller } from "react-hook-form";
import type { TModalSocialOfferFormResolver } from "../logics/resolver";

interface IModalSocialOfferFormFieldChallengesProps {
  control: Control<TModalSocialOfferFormResolver>;
}

export const ModalSocialOfferFormFieldChallenges = ({ control }: IModalSocialOfferFormFieldChallengesProps) => {
  const { challenges } = useGlobalContext();

  return (
    <Controller
      name="challenges"
      control={control}
      defaultValue={[]}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <Autocomplete
          multiple
          limitTags={1}
          value={value}
          onChange={(_, value) => onChange(value)}
          getOptionLabel={(v) => v.name}
          isOptionEqualToValue={(a, b) => a._id === b._id}
          options={challenges}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Thématique liée *"
              error={Boolean(error)}
              helperText={error?.message}
              inputRef={ref}
            />
          )}
          size="small"
          disableCloseOnSelect
          slotProps={{
            chip: {
              color: "yellow",
              size: "small",
              sx: { [`&.${autocompleteClasses.tag}`]: { mt: 0 } },
            }
          }}
        />
      )}
    />
  );
};
